import * as React from "react";

function IconPennant2({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-pennant-2" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/pennant-2"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M16 21h-4" /><path d="M14 21v-18" /><path d="M14 4l-9 4l9 4" /></svg>;
}

export default IconPennant2;